import { Column } from '../../../lib';

export const defaultRoomListColumns: Column[] = [
    {
        title: 'RBR.ROOM_LIST.NAME',
        name: 'name',
        flex: 1.5
    },
    {
        title: 'RBR.ROOM_LIST.AREA',
        name: 'area',
        flex: 1
    },
    {
        title: 'RBR.ROOM_LIST.HEIGHT',
        name: 'height',
        flex: 1
    },
    {
        title: 'RBR.ROOM_LIST.TYPE',
        name: 'type',
        flex: 1
    },
    {
        title: 'RBR.ROOM_LIST.COOLING',
        name: 'isCooled',
        flex: 1
    },
    {
        title: 'RBR.ROOM_LIST.COOLING_LOAD',
        name: 'coolingLoad',
        flex: 1
    },
    {
        title: 'RBR.ROOM_LIST.HEATING',
        name: 'isHeated',
        flex: 1
    },
    {
        title: 'RBR.ROOM_LIST.HEATING_LOAD',
        name: 'heatingLoad',
        flex: 1
    },
    {
        title: '',
        name: 'actions'
    }
];
